export const isBlank = (input: string): boolean => {
    return input === null || !/\S/.test(input);
  };

  export const isNotBlank = (input: string): boolean => {
    return input !== null && input !== '';
  };